var Theme = {};

const BREAKPOINT_LARGEDESKTOP = 1800;
const BREAKPOINT_MEDIUMDESKTOP = 1500;
const BREAKPOINT_DESKTOP = 1360;
const BREAKPOINT_LAPTOP = 1200;
const BREAKPOINT_TABLETHOR = 1024;
const BREAKPOINT_TABLET = 768;
const BREAKPOINT_PHABLET = 576;
const BREAKPOINT_MOBILE = 325;

var previousScrollTop = 0;

(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.Theme = {};

  /**
   * Constructeur
   */
  Theme.Common = function () {
    // Éléments
    this.elements = {
      htmlBody: $('html, body'),
      body: $('body'),
      page: $('#page'),
    };

    this.elements.externalLinks = this.elements.page.find('a[href^="http"]');
    this.elements.openInNewWindowLinks = this.elements.page.find('a[href$=".pdf"]');

    // Variables
    this.menuScrollOffset = 110;
    this.langcode = drupalSettings.path.currentLanguage || 'fr';

    return this;
  };

  /**
   * Méthodes
   */
  Theme.Common.prototype = {
    load: function (className, options) {
      if (Theme[className] !== undefined) {
        return new Theme[className](this, options);
      } else {
        console.error('Class "Theme.' + className + '" not found.');
      }
    },
    autoload: function (options) {
      var self = this;

      if (options !== undefined) {
        $.each(options, function (className, condition) {
          if (self.elements.body.is(condition)) {
            return self.load(className).init();
          }
        });

      } else {
        console.error('Options is undefined.');
      }
    },

    /**
     * Init common
     */
    init: function () {
      this.cookieTarteAuCitronHandler();
      this.externalLinksHandler();
      this.openInNewWindowHandler();
      this.anchorLinksHandler();
    },

    /** Slider Swipper */
    buildSliderPrevArrow: function () {
      return $('<button type="button" class="swiper-button-prev"><span class="sr-only">' + Drupal.t('Previous') + '</span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M7.852 16.426c.4.447 1.04.49 1.46.146.421-.345.49-1.04.146-1.46L6.02 10.94h9.745a1.035 1.035 0 1 0 0-2.07H6.02l3.438-4.17c.344-.42.267-1.107-.145-1.46-.425-.366-1.117-.276-1.46.145L3.023 9.248c-.314.442-.287.888 0 1.315l4.828 5.863Z" clip-rule="evenodd"/></svg></button>');
    },
    buildSliderNextArrow: function () {
      return $('<button type="button" class="swiper-button-next"><span class="sr-only">' + Drupal.t('Next') + '</span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M11.747 3.574c-.4-.447-1.04-.49-1.46-.146-.42.345-.49 1.04-.146 1.46L13.58 9.06H3.835a1.035 1.035 0 1 0 0 2.07h9.745l-3.438 4.17c-.344.42-.266 1.107.146 1.46.425.366 1.116.276 1.46-.145l4.829-5.863c.314-.441.287-.887 0-1.314l-4.829-5.863Z" clip-rule="evenodd"/></svg></button>');
    },
    /**
     *
     * @param $sliderWrapper
     * @param options
     * @returns {*}
     */
    initDefaultSwiper: function ($sliderWrapper, options) {
      let swiperOptions = $.extend(true, {
        navigation: {
          enabled: true,
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        pagination: {
          clickable: true,
          el: '.swiper-pagination',
          enabled: true,
        },
        slidesPerView: 'auto',
        spaceBetween: 30,
        on: {
          resize: function (swiper) {
            let enabled = swiper.enabled;

            if (enabled) {
              $(swiper.el).addClass('is-enabled').removeClass('is-disabled');
            } else {
              $(swiper.el).addClass('is-disabled').removeClass('is-enabled');
            }
          },
          init: function (swiper) {
            let enabled = swiper.enabled;

            if (enabled) {
              $(swiper.el).addClass('is-enabled').removeClass('is-disabled');
            } else {
              $(swiper.el).addClass('is-disabled').removeClass('is-enabled');
            }
          },
        },
      }, options);

      $sliderWrapper.addClass('swiper');

      // Ajoute la classe wrapper si non déclarée en html
      if ($sliderWrapper.children('.swiper-wrapper').length === 0) {
        $sliderWrapper.wrapInner('<div class="swiper-wrapper"></div>');
      }
      // Ajoute la classe slide si non déclarée
      if ($sliderWrapper.children('.swiper-wrapper').children('.swiper-slide').length === 0) {
        $sliderWrapper.children('.swiper-wrapper').children().addClass('swiper-slide');
      }

      // Ajoute la navigation si non déclarée en HTML
      if ($sliderWrapper.find('.swiper-navigation').length === 0) {
        $sliderWrapper.prepend($('<div class="swiper-navigation"></div>'));
      }
      if (swiperOptions.navigation.enabled === true) {
        $sliderWrapper.find('.swiper-navigation').append(this.buildSliderPrevArrow()).append(this.buildSliderNextArrow());
      }

      // Ajoute la pagination si non déclarée en HTML
      if ($sliderWrapper.find('.swiper-pagination').length === 0) {
        $sliderWrapper.prepend($('<div class="swiper-pagination"></div>'));
      }

      // Build instance
      let swiperInstance = new Swiper($sliderWrapper[0], swiperOptions);
      $sliderWrapper.addClass('slider slider--primary-swiper');

      // Move navigation outisde to improve styles
      if ($sliderWrapper.find('.swiper-navigation').length) {
        $sliderWrapper.find('.swiper-navigation').detach().insertBefore($sliderWrapper);
      }

      // Move navigation outisde to improve styles
      if ($sliderWrapper.find('.swiper-pagination').length) {
        $sliderWrapper.find('.swiper-pagination').detach().insertAfter($sliderWrapper);
      }

      return swiperInstance;
    },

    /**
     * Gestionnaire de CookieNotice
     */
    cookieTarteAuCitronHandler: function () {
      // lien pour ouvir le gestionnaire de cookies
      $('.link-cookies').on('click touch', function (e) {
        e.preventDefault();
        tarteaucitron.userInterface.openPanel();
      });
    },

    /**
     * Gestionnaire des liens externes
     */
    externalLinksHandler: function () {
      if (this.elements.externalLinks.length) {
        this.elements.externalLinks.each(function (i, link) {
          link = $(link);

          if (link.attr('href').indexOf(window.location.host) === -1) {
            link.attr('target', '_blank');
          }
        });
      }
    },

    /**
     * Gestionnaire pour l'ouverture de lien dans un nouvel onglet
     */
    openInNewWindowHandler: function () {
      if (this.elements.openInNewWindowLinks.length) {
        this.elements.openInNewWindowLinks.on('click', function (event) {
          event.preventDefault();
          window.open($(event.currentTarget).attr('href'));
        });
      }
    },

    /**
     * Gestionnaire des ancres
     */
    anchorLinksHandler: function () {
      var self = this;

      self.elements.page.on('click', 'a[href*="#"]:not([href="#"])', function (event) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            event.preventDefault();

            self.scrollTop(target.offset().top);
          }
        }
      });
    },

    /**
     * Init Send Data Layer
     * @param action
     * @param category
     * @param data
     */
    setDataLayerEvent: function (action, category, data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
      
      if (drupalSettings.env !== 'prod') {
        console.log('dataLayer :: ' + category + ' > ' + action + ' = ' + JSON.stringify(data));
      }
    },

    /**
     * Scroll top
     *
     * @param offset
     * @param speed
     */
    scrollTop: function (offset, speed) {
      speed = speed || 500;

      this.elements.htmlBody.animate({
        scrollTop: (offset - this.menuScrollOffset),
      }, speed);

      return this;
    },

  };

  /**
   * Load Themes
   * @type {{attach: attach, detach: detach}}
   */
  Drupal.behaviors.drupTheme = {
    attach: function (context, settings) {
      if (context.body !== undefined) {

        $(once('drupTheme', context === document ? 'html' : context)).each(function () {
          Drupal.Theme = new Theme.Common();
          Drupal.Theme.init();
          Drupal.Theme.load('all').init();
          Drupal.Theme.load('dataLayer').init();
        });
      }
      // modal avis : rappel du initPageReview
      else if ($(context).is('.notation-reviews')) {
        //Drupal.Theme = new Theme.Common();
        Drupal.Theme.load('all').initPageReview();
      }
    },
  };

  // Override Ajax Loader
  Drupal.Ajax.prototype.setProgressIndicatorFullscreen = function () {
    this.progress.element = $('<div class="ajax-progress ajax-progress-fullscreen"><svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="rotate(0 50 50)"><rect x="45" y="30" rx="9" ry="6" width="10" height="10" fill="#fff"><animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="-0.875s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(45 50 50)"><rect x="45" y="30" rx="9" ry="6" width="10" height="10" fill="#fff"><animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(90 50 50)"><rect x="45" y="30" rx="9" ry="6" width="10" height="10" fill="#fff"><animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="-0.625s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(135 50 50)"><rect x="45" y="30" rx="9" ry="6" width="10" height="10" fill="#fff"><animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(180 50 50)"><rect x="45" y="30" rx="9" ry="6" width="10" height="10" fill="#fff"><animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="-0.375s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(225 50 50)"><rect x="45" y="30" rx="9" ry="6" width="10" height="10" fill="#fff"><animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(270 50 50)"><rect x="45" y="30" rx="9" ry="6" width="10" height="10" fill="#fff"><animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="-0.125s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(315 50 50)"><rect x="45" y="30" rx="9" ry="6" width="10" height="10" fill="#fff"><animate attributeName="opacity" values="1;0" times="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animate></rect></g></svg></div>');
    $('body').after(this.progress.element);
  };

}(jQuery, Drupal, drupalSettings));

